/* Coaster Rizz — scroll-linked background gradient.  D-137.
 *
 * Publishes one number, --rizz-scroll, on <html>: 0 at the top of the page,
 * 1 at the bottom.  assets/rizz-motion.css uses it to move the two colour
 * blooms behind the neutral bands of the page.  Nothing else reads it.
 *
 * The value is written straight from the scroll handler rather than from a
 * requestAnimationFrame callback: rAF is paused in a background tab, which
 * left the gradient frozen at 0 while the page had plainly been scrolled.
 * Writing one custom property per scroll event is cheap and always runs.
 *
 * If the visitor asks for reduced motion the value is parked at a fixed
 * 0.35 and no listener is attached, so the gradient is pretty and still.
 */
(function () {
  var root = document.documentElement;
  var last = -1;

  function set(value) {
    if (value === last) return;
    last = value;
    root.style.setProperty('--rizz-scroll', value.toFixed(4));
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  if (reduce && reduce.matches) {
    set(0.35);
    return;
  }

  function measure() {
    var travel = Math.max(1, root.scrollHeight - window.innerHeight);
    var y = window.pageYOffset || root.scrollTop || 0;
    var p = y / travel;
    set(p < 0 ? 0 : p > 1 ? 1 : p);
  }

  window.addEventListener('scroll', measure, { passive: true });
  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('load', measure);
  document.addEventListener('visibilitychange', measure);

  if (reduce && reduce.addEventListener) {
    reduce.addEventListener('change', function (e) {
      if (e.matches) {
        window.removeEventListener('scroll', measure);
        window.removeEventListener('resize', measure);
        last = -1;
        set(0.35);
      }
    });
  }

  measure();
})();
